export const BASE_URL = 'https://rolling-api.vercel.app/4-13/recipients/';
export const DELETE_URL = 'https://rolling-api.vercel.app/4-13/';
